<template>
  <div class="home-container">
    <!-- Bookmark Modal -->
    <div class="modal-mask" v-if="showBookmarkModal">
       <!-- (Existing Bookmark Content) -->
       <div class="modal-box">
          <div class="modal-header">
             <span>收藏本站 永不迷路</span>
             <div class="close-btn" @click="toggleBookmark">
               <van-icon name="cross" size="20" color="#fff" />
             </div>
          </div>
          <div class="modal-body">
             <div class="green-text">
                重要提示!!!请截图保存本站最新网址! ! ! 已付款的请在已购处播放!
             </div>
             <div class="orange-label">永久网址:</div>
             <div class="url-row">
                <span class="url-text">http://36x9.cn</span>
                <button class="copy-btn" @click="copyUrl">复制</button>
             </div>
             <div class="qr-label">截图保存本站二维码:</div>
             <div class="qr-box">
                <img src="https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=http://36x9.cn" alt="QR" />
             </div>
          </div>
       </div>
    </div>

    <!-- Payment Modal -->
    <div class="modal-mask" v-if="showPayModal">
        <div class="modal-box pay-box">
            <div class="pay-header">
                视频在已购页面观看
                <div class="close-btn" @click="showPayModal = false"><van-icon name="cross" color="#fff"/></div>
            </div>
            
            <div class="pay-video-info">
                <div class="pay-title">{{ currentVideo.title }}</div>
                <div class="pay-cover">
                    <img :src="currentVideo.cover" />
                </div>
            </div>

            <div class="pay-options">
                <button 
                  v-for="item in pricingList" 
                  :key="item.type" 
                  class="pay-btn" 
                  :class="item.isMembership ? 'btn-orange' : 'btn-pale'"
                  @click="handleBuy(item)"
                >
                  {{ item.name }}¥{{ item.price }}
                </button>
            </div>
        </div>
    </div>

    <!-- Top Header -->
    <div class="top-header">
      <div class="header-left">
        <button class="btn-blue" @click="$router.push('/purchased')">已购买</button>
        <button class="btn-blue" @click="$router.push('/user')">账号</button>
      </div>
      <div class="search-box">
        <input type="text" placeholder="搜索国产、日韩" v-model="searchValue" @keyup.enter="performSearch" />
        <van-icon name="search" color="#f7b500" size="20" @click="performSearch" />
      </div>
      <div class="header-right">
        <button class="btn-blue">客服</button>
      </div>
    </div>

    <!-- Category Grid -->
    <div class="category-grid">
      <div 
        v-for="cat in categories" 
        :key="cat" 
        class="cat-item"
        :class="{ active: activeCategory === cat }"
        @click="switchCategory(cat)"
      >
        {{ cat }}
      </div>
    </div>

    <!-- Announcement/Marquee -->
    <div class="marquee-bar">
      <div class="marquee-text">注册账号!未注册账号，请勿随意切换网络，导致购买的单片丢失!</div>
    </div>

    <!-- Category Header (Image 1 Style) -->
    <div class="category-header">
       <span class="cat-badge">{{ activeCategory }}</span>
       <span class="cat-label"> 相关影片:</span>
    </div>

    <!-- Video List -->
    <div class="content-area">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <div class="video-contain">
          <div class="video-box" v-for="(item, index) in videoList" :key="index" @click="goToPlayer(item)">
            <div class="cover-wrapper">
               <van-image :src="item.cover" fit="cover" class="cover-img">
                  <template v-slot:loading><van-loading type="spinner" /></template>
               </van-image>
            </div>
            <div class="video-title clamp-2">{{ item.title }}</div>
          </div>
        </div>
        <div v-if="videoList.length === 0" class="empty-tip">暂无视频</div>
      </van-pull-refresh>
    </div>

    <!-- Bottom Navigation -->
    <div class="bottom-nav">
      <div class="nav-item" @click="handleHomeClick">
        <div class="nav-btn btn-dark">首页</div>
      </div>
      <div class="nav-item" @click="$router.push('/purchased')">
        <div class="nav-btn btn-yellow">已购买</div>
      </div>
      <div class="nav-item" @click="$router.push('/user')">
        <div class="nav-btn btn-yellow">账号</div>
      </div>
      <div class="nav-item" @click="toggleBookmark">
        <div class="nav-btn btn-dark">收藏本站</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchValue: '',
      activeCategory: '推荐',
      activeNav: 0,
      refreshing: false,
      showBookmarkModal: false,
      showPayModal: false,
      currentVideo: {},
      categories: [
        '推荐', '巨乳', '自拍', '偷情', '偷拍', '萝莉', '动漫', '强奸', '迷奸', '乱伦', 
        '虐待', '网红', '制服', '麻豆', '果冻', 'SM', '重口', '处女', '熟女', '换妻', 
        '明星', '人妻', '孕妇', '人妖', '人兽', '爆菊', '潮喷', '剧情', '无码', '日韩', '精品'
      ],
      videoList: [],
      pricingList: []
    }
  },
  created() {
    this.fetchVideos();
    this.fetchPricing();
  },
  methods: {
    async fetchVideos(category = '', search = '') {
      if(!category && !search) category = this.activeCategory;
      try {
        const params = { random: true };
        if (category) params.category = category;
        if (search) params.search = search;

        const { data } = await this.$http.get('/videos', { params });
        this.videoList = data.map(v => {
            let cover = v.coverUrl || 'https://dummyimage.com/300x200/333/fff.png&text=Video';
            // If cover is a local path, prefix with backend URL
            if (cover.startsWith('/covers/')) {
                cover = '' + cover;
            }
            return {
                id: v.id,
                title: v.title,
                cover: cover,
                duration: v.duration,
                views: v.views,
                videoUrl: v.videoUrl
            };
        });
      } catch (e) {
        console.error(e);
      } finally {
        this.refreshing = false;
      }
    },
    performSearch() {
        if (!this.searchValue.trim()) return;
        this.activeCategory = ''; // Clear category highlight when searching
        this.fetchVideos('', this.searchValue);
    },
    switchCategory(cat) {
      this.activeCategory = cat;
      this.searchValue = ''; // Clear search when switching category
      this.fetchVideos(cat);
    },
    onRefresh() {
      this.fetchVideos();
    },
    goToPlayer(item) {
        // Mock Permission Check
        const membership = localStorage.getItem('membership_expire');
        const purchased = JSON.parse(localStorage.getItem('purchased_ids') || '[]');
        const isVip = membership && new Date(membership) > new Date();
        const isOwned = purchased.includes(item.id);

        if (isVip || isOwned) {
            // Use query params for better persistence
            this.$router.push({ 
                path: '/player', 
                query: { id: item.id, url: item.videoUrl, title: item.title }
            });
        } else {
            this.currentVideo = item;
            this.showPayModal = true;
        }
    },
    handleBuy(item) {
      // Navigate to Cashier page for payment method selection
      this.showPayModal = false; // Close modal first
      this.$router.push({
        path: '/cashier',
        query: {
          amount: item.price,
          type: item.type,
          title: item.name || '视频购买',
          videoId: this.currentVideo?.id || null,
          videoTitle: this.currentVideo?.title || 'Unknown Video'
        }
      });
    },
    async fetchPricing() {
        try {
           const { data } = await this.$http.get('/pricing');
           this.pricingList = data;
        } catch(e) {
            console.log('Failed to fetch pricing:', e);
        }
    },
    toggleBookmark() {
        this.showBookmarkModal = !this.showBookmarkModal;
    },
    handleHomeClick() {
        if (this.$route.path === '/home') {
            this.activeCategory = '推荐'; // Reset category
            this.fetchVideos('推荐'); 
            window.scrollTo(0, 0); 
        } else {
            this.$router.push('/home');
        }
    },
    copyUrl() {
        const input = document.createElement('input');
        input.setAttribute('value', 'http://36x9.cn');
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        alert('网址已复制');
    }
  }
}
</script>

<style scoped>
/* Reset & Layout */
.home-container {
  background-color: #000;
  min-height: 100vh;
  padding-bottom: 60px; /* Space for footer */
  color: #fff;
  font-family: sans-serif;
}

/* Header */
.top-header {
  background-color: #000;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header-left, .header-right {
  display: flex;
  gap: 5px;
}
.btn-blue {
  background-color: #0000ff; /* Proper Blue from image */
  color: white;
  border: none;
  border-radius: 4px;
  padding: 5px 10px;
  font-size: 14px;
  font-weight: bold;
}
.search-box {
  flex: 1;
  margin: 0 10px;
  background-color: #333;
  border-radius: 20px;
  display: flex;
  align-items: center;
  padding: 5px 10px;
}
.search-box input {
  background: transparent;
  border: none;
  color: #fff;
  width: 100%;
  margin-right: 5px;
}
.search-box input::placeholder {
  color: #888;
}

/* Category Grid */
.category-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr); /* Dense grid */
  gap: 5px;
  padding: 5px;
}
.cat-item {
  background-color: #ffaa00; /* Orange/Yellow */
  color: #000;
  text-align: center;
  padding: 6px 0;
  border-radius: 4px;
  font-size: 13px;
  font-weight: bold;
  cursor: pointer;
}
.cat-item.active {
  background-color: #fff; 
  color: #000;
}

/* Marquee */
.marquee-bar {
  background-color: #0000ff;
  color: white;
  padding: 5px;
  white-space: nowrap;
  overflow: hidden;
  font-size: 14px;
  margin-top: 5px;
}
.marquee-text {
  display: inline-block;
  animation: scroll-left 15s linear infinite;
}

@keyframes scroll-left {
  0% { transform: translateX(100%); }
  100% { transform: translateX(-100%); }
}

/* Category Header */
.category-header {
    background-color: #000;
    padding: 10px;
    display: flex;
    align-items: center;
}
.cat-badge {
    border: 1px solid #ffaa00;
    color: #ffaa00;
    padding: 2px 8px;
    border-radius: 4px;
    margin-right: 10px;
    font-size: 14px;
}
.cat-label {
    color: #fff;
    font-size: 16px;
    font-weight: bold;
}

/* Content */
.content-area {
    padding: 10px 5px;
}
.video-contain {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.video-box {
    width: 49%;
    margin-bottom: 10px;
    background: #1a1a1a;
    border-radius: 4px;
    overflow: hidden;
}
.cover-wrapper {
    height: 110px;
    width: 100%;
    position: relative;
    background: #000;
}
.cover-img {
    width: 100%;
    height: 100%;
}
.video-title {
    padding: 8px 5px;
    font-size: 14px;
    line-height: 1.4;
    color: #fff;
}
.empty-tip {
    text-align: center;
    padding: 20px;
    color: #666;
}

/* Bottom Nav */
.bottom-nav {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #111;
    display: flex;
    padding: 5px 0;
    border-top: 1px solid #333;
    z-index: 100;
}
.nav-item {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
}
.nav-btn {
    width: 80%;
    text-align: center;
    padding: 8px 0;
    font-size: 14px;
    border-radius: 4px;
    font-weight: bold;
}
.btn-dark {
    background-color: #222;
    color: white;
    border: 1px solid #444;
}
.btn-yellow {
    background-color: #ffaa00;
    color: black;
}

/* Modal Styles */
.modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.8);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
}
.modal-box {
    width: 85%;
    background-color: #1a1a1a;
    border-radius: 8px;
    padding: 15px;
    position: relative;
    border: 1px solid #333;
}
.modal-header {
    text-align: center;
    color: #ffaa00;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 15px;
    position: relative;
}
.close-btn {
    position: absolute;
    right: 0;
    top: -5px;
    cursor: pointer;
    border: 1px solid #fff;
    border-radius: 50%;
    padding: 2px;
}
.modal-body {
    text-align: center;
}
.green-text {
    color: #00ff00; /* Bright Green */
    font-size: 16px;
    font-weight: bold;
    line-height: 1.5;
    margin-bottom: 15px;
    text-shadow: 0 0 2px #000;
}
.orange-label {
    color: #ffaa00;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 5px;
}
.url-row {
    margin-bottom: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
}
.url-text {
    color: #00ff00;
    font-size: 24px;
    font-weight: bold;
}
.copy-btn {
    background-color: #0000ff;
    color: white;
    border: none;
    border-radius: 15px;
    padding: 2px 10px;
    font-size: 12px;
}
.qr-label {
    color: #ffaa00;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 10px;
}
.qr-box {
    background-color: #fff;
    padding: 10px;
    display: inline-block;
    border-radius: 4px;
}
.qr-box img {
    width: 150px;
    height: 150px;
    display: block;
}

/* Payment Modal Specifics */
.pay-box {
    background-color: #111;
    border: 1px solid #444;
    padding: 0;
    overflow: hidden;
}
.pay-header {
    background-color: #222;
    padding: 10px;
    text-align: center;
    color: #ffaa00;
    font-weight: bold;
    position: relative;
    font-size: 16px;
}
.pay-video-info {
    padding: 10px;
}
.pay-title {
    color: #fff;
    font-size: 14px;
    margin-bottom: 10px;
    line-height: 1.4;
}
.pay-cover {
    width: 100%;
    height: 180px;
    background: #000;
}
.pay-cover img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
.pay-options {
    padding: 10px 20px 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-height: 300px;
    overflow-y: auto;
}
.pay-btn {
    width: 100%;
    padding: 12px;
    border-radius: 4px;
    border: none;
    font-weight: bold;
    font-size: 16px;
    cursor: pointer;
}
.btn-pale {
    background-color: #ffffdd;
    color: #000;
}
.btn-orange {
    background-color: #ffaa00;
    color: #000;
    font-weight: 800; /* Extra bold for emphasis */
}
</style>
